import DOMPurify from 'dompurify';

const RICH_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'strike',
  'ul',
  'ol',
  'li',
  'a',
  'blockquote',
  'code',
  'pre',
  'span',
];

/** Strips tags for AI prompts, checklist length, empty checks. */
export function stripHtmlToText(html: string): string {
  if (!html.trim()) return '';
  if (typeof document === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body?.textContent?.replace(/\s+/g, ' ').trim() ?? '';
}

export function isRichTextEmpty(html: string): boolean {
  return stripHtmlToText(html).length === 0;
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Turns plain AI output into safe HTML paragraphs for TipTap. */
export function plainTextToRichHtml(plain: string): string {
  const t = plain.trim();
  if (!t) return '';
  const blocks = t.split(/\n{2,}/);
  return blocks
    .map((block) => `<p>${escapeHtml(block).replace(/\n/g, '<br>')}</p>`)
    .join('');
}

/** Defense in depth before save or render. */
export function sanitizeRichHtml(dirty: string): string {
  const s = dirty.trim();
  if (!s) return '';
  return DOMPurify.sanitize(s, {
    ALLOWED_TAGS: RICH_ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    ADD_ATTR: ['rel'],
    ALLOW_DATA_ATTR: false,
  });
}

/** Normalizes empty rich content to null for API payloads. */
export function richHtmlToPayload(html: string): string | null {
  const sanitized = sanitizeRichHtml(html);
  if (!sanitized || isRichTextEmpty(sanitized)) return null;
  return sanitized;
}
